module.exports = __webpack_public_path__ + "img/howto_sp02.a636372a.png";